import {
    Box,
    Button,
    HStack,
    Image,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr
} from '@chakra-ui/react';
import React, { useRef } from 'react';
import { Logo, useTableColors } from '../../Utils';
import PdfGeneratorPsc from '../../components/PdfGeneratorPsc';

const ExportPSCModal = ({ pscData, isOpen, onClose }) => {
    const coolors = useTableColors();
    // Function to split array into chunks of 12 items
    const chunkArray = (arr, chunkSize) => {
        const chunks = [];
        for (let i = 0; i < arr.length; i += chunkSize) {
            chunks.push(arr.slice(i, i + chunkSize));
        }
        return chunks;
    };

    // Split the pscData into chunks of 12 items
    const pscChunks = chunkArray(pscData, 14);

    // Create refs for each chunk outside of the loop
    const chunkRefs = useRef(pscChunks.map(() => React.createRef()));
    // const formattedString = inputString.replace(/, /g, '\n');
    function formatStringWithNewLines(inputString) {
        // Normalize spaces around commas
        const normalizedString = inputString.replace(/\s*,\s*/g, ', '); // Ensure only one space after each comma

        // Replace commas with newlines
        return normalizedString.split(', ').map((line, index) => (
            <span style={{
                color: "#1a375d",
                fontSize: 13
            }} key={index}>
                {line}
                <br />
            </span>
        ));
    }
    return (
        <>
            <Modal isOpen={isOpen} onClose={onClose} size="6xl">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        <PdfGeneratorPsc chunkRefs={chunkRefs} name="PSC Locations" title="Download PSC" />
                    </ModalHeader>

                    {pscChunks.map((pscChunk, chunkIndex) => (
                        <Box key={chunkIndex} ref={chunkRefs.current[chunkIndex]}>
                            <ModalBody>
                                {/* Header */}
                                <Box bg="#1a365d" color="white" p={10}>
                                    <HStack>
                                        <Image src={Logo} alt="Logo" boxSize="150px" w={200} objectFit="contain" />
                                        <Box textAlign="center" ml="15%">
                                            <Text fontSize="4xl" fontWeight="bold">Patient Service Centers</Text>
                                            <Text>info@mydlslab.com | +1(888)-882-3330</Text>
                                        </Box>
                                    </HStack>
                                </Box>

                                {/* Table */}
                                <Table size="md" variant="simple" mt={4} borderWidth={1} borderColor="#ccc">
                                    <Thead bg="#1a365d">
                                        <Tr>
                                            <Th w="35%" borderRight="1px solid #ccc" h={20} color="#f4b31b" fontWeight="bold" textAlign="center">
                                                Location
                                            </Th>
                                            <Th w="30%" borderRight="1px solid #ccc" color="#f4b31b" fontWeight="bold" textAlign="center">
                                                Address
                                            </Th>
                                            <Th w="35%" color="#f4b31b" fontWeight="bold" textAlign="center">
                                                Hours of Operation
                                            </Th>
                                        </Tr>
                                    </Thead>
                                    <Tbody>
                                        {pscChunk.map((psc, index) => (
                                            <Tr
                                                key={index}
                                                bg={index % 2 === 0 ? "#f9f9f9" : "white"}
                                                color="#1a1a1a"
                                                _hover={{ bg: "#e2e8f0", color: "#000" }}
                                            >
                                                <Td borderRight="1px solid #ccc" textAlign="left" fontWeight="bold" fontSize="sm">
                                                    {psc.name}
                                                </Td>
                                                <Td borderRight="1px solid #ccc" textAlign="left" fontSize="sm">
                                                    {psc.address}
                                                </Td>
                                                <Td textAlign="left" fontSize="sm">
                                                    {formatStringWithNewLines(psc.hoursOfOperation)}
                                                </Td>
                                            </Tr>
                                        ))}
                                    </Tbody>
                                </Table>
                            </ModalBody>
                        </Box>
                    ))}

                    <ModalFooter>
                        <Button size="xs" colorScheme="blue" mr={3} onClick={onClose}>
                            Close
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>


        </>
    );
};

export default ExportPSCModal;
